import { NotificationService } from 'src/app/shared/services/notification.service';
import { inject, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SelectItem } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';

import { BaseServices } from '../../kuba.services';
import { HelperService, PdfSetting } from './../../../_services/helper.service';
import { BusinessServices } from './../../businesses/services/business.services';
import { AdminUserService } from './../services/adminuser.service';
import { AdminUser } from '../models/adminuser';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ConfigService } from '../../../_services/config.service';

@Component({
    selector: 'adminuser-list',
    templateUrl: 'adminuser-list.component.html',
  standalone: false
})
export class AdminUserListComponent implements OnInit {
    //#region variables
    private readonly notifications = inject(NotificationService);
    users: AdminUser[];
    AdminPortal = [1]; // Admin
    private subscriptions: Subscription[] = [];
    additionalData: any;
    showReassignDialog = false;
    deleteUserId: number;
    selectedTargetAdminId: number;
    adminUserOptions: SelectItem[] = [];
    //#endregion

    //#region constructor
    /**
     * Constructor
     * @param route {ActivatedRoute}
     * @param confirmationService {ConfirmationService}
     * @param adminUserService {AdminUserService}
     * @param businessService {BusinessServices}
     */
    constructor(
        private route: ActivatedRoute,
        private confirmationService: ConfirmationService,
        private adminUserService: AdminUserService,
        private businessService: BusinessServices,
        private translate: TranslateService
    ) {

        this.subscriptions.push(
            this.translate.stream('FILENAME').subscribe(val => {
              this.additionalData = {
                fileName: val.ADMIN_USER_LIST,
                header: 'Admin Users List',
                businessId: BaseServices.BusinessId,
                cultureInfo: BaseServices.userCultureInfo(),
                columnNames: [
                    { title: 'Name', dataKey: 'Name' },
                    { title: 'User Name', dataKey: 'Username' },
                    { title: 'Role', dataKey: 'Role' },
                    { title: 'Account Owner', dataKey: 'Owner.' },
                    { title: 'Mobile', dataKey: 'Mobile' },
                    { title: 'Email', dataKey: 'Email' },
                    { title: 'Creator Name', dataKey: 'CreatorName' }
                ]
              };
            })
          );
    }
    //#endregion

    //#region page-event
  /**
   * initialization
   */
    ngOnInit(): void {
        document.querySelector("body").classList.remove("opened");
        let list = this.route.snapshot.data['list'];
       
        this.users = list;
    }
    //#endregion

    //#region methods
  /**
   * Referesh the table in data
   */
    fetchData() {
        this.subscriptions.push(this.adminUserService
            .getAdminCreatedUsers()
            .subscribe((list: AdminUser[]) => {
                this.users = list;
            }));
    }
    /**
     * delete the user — opens reassign dialog first
     * @param id {number}
     */
    delete(id: number) {
        this.deleteUserId = id;
        this.selectedTargetAdminId = null;
        this.subscriptions.push(this.adminUserService.getAdminCreatedUsers().subscribe((adminUsers: AdminUser[]) => {
            this.adminUserOptions = adminUsers
                .filter((u: AdminUser) => u.Id !== id)
                .map((u: AdminUser) => ({ label: u.Name, value: u.Id }));
            if (this.adminUserOptions.length === 0) {
                this.selectedTargetAdminId = 2;
                this.confirmDelete();
            } else {
                this.showReassignDialog = true;
            }
        }));
    }

    confirmDelete() {
        if (!this.selectedTargetAdminId) return;
        this.showReassignDialog = false;
        this.subscriptions.push(this.adminUserService
            .deleteAdminUser(this.deleteUserId, this.selectedTargetAdminId)
            .subscribe((result: any) => {
                if (result) {
                    this.notifications.success('UI_NOTIFICATIONS.DELETED');
                    this.fetchData();
                }
            }));
    }

    cancelDelete() {
        this.showReassignDialog = false;
        this.deleteUserId = null;
        this.selectedTargetAdminId = null;
    }

    exportPdf() {
        let pdfSetting = new PdfSetting();
        pdfSetting.date = 'Date' + HelperService.formatDate(new Date());
        pdfSetting.businessName = BaseServices.BusinessName;
        pdfSetting.pageHeader = 'User List';
        let columns: any = [
            { title: 'Name', dataKey: 'Name' },
            { title: 'User Name', dataKey: 'Username' },
            { title: 'Role', dataKey: 'Role' },
            { title: 'Account Owner', dataKey: 'Owner.' },
            { title: 'Mobile', dataKey: 'Mobile' },
            { title: 'Email', dataKey: 'Email' },
            { title: 'Creator Name', dataKey: 'CreatorName' }
        ];
        HelperService.generatePdf(
            this.users,
            columns,
            'User list',
            pdfSetting,
            'l'
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach((sub, i) => {
          sub.unsubscribe();
        });
      }
    //#endregion
}
